<section class="login">
  <div class="container">
    <div class="row justify-content-center">
      <div class="col-12 col-sm-6 col-lg-6">
        <div class="login-box">
          <h3 style="text-align: center; font-weight:bold; margin-bottom:20px;">Connexion</h3>
          <div>
            <div class="form-check rad">
              <input type="radio" id="candidat" name="typeuser" value="candidat" checked
                (click)="choiceProfile('candidat')">
              <label for="candidat" (click)="choiceProfile('candidat')">CANDIDAT</label>
            </div>
            <div class="form-check rad">
              <input type="radio" id="consultant" name="typeuser" value="consultant"
                (click)="choiceProfile('consultant')">
              <label for="consultant" (click)="choiceProfile('consultant')">CONSULTANT</label>
            </div>
            <div class="form-check rad">
              <input type="radio" id="entreprise" name="typeuser" value="entreprise"
                (click)="choiceProfile('entreprise')">
              <label for="entreprise" (click)="choiceProfile('entreprise')">ENTREPRISE</label>
            </div>
          </div>
          <form [formGroup]="signInForm" (ngSubmit)="onSubmitForm()">
            <div class="mb-3" style="margin: 20px auto;">
              <input type="email" class="form-control" id="email" style="text-transform: lowercase !important;"
                placeholder="Email">
            </div>

            <div class="mb-3" style="margin: 20px auto;">
              <input type="password" class="form-control" id="password" formControlName="password"
                placeholder="Mot de passe ">
            </div>

            <!-- <div style="text-align: right; margin: 10px 0px 10px;"><a href="" style="font-size: 13px; color: #FF5A00;">Mot de passe oublié ?</a></div> -->

            <div class="form-group" *ngIf="typeUser == 'candidat'">
              <a [routerLink]="['/mot-de-passe-oublie', 'candidat']" style="font-size: 13px; color: #FF5A00;">Mot de
                passe oublié ?</a>
            </div>
            <div class="form-group" *ngIf="typeUser == 'consultant'">
              <a [routerLink]="['/mot-de-passe-oublie', 'consultant']" style="font-size: 13px; color: #FF5A00;">Mot de
                passe oublié ?</a>
            </div>
            <div class="form-group" *ngIf="typeUser == 'entreprise'">
              <a [routerLink]="['/mot-de-passe-oublie', 'entreprise']" style="font-size: 13px; color: #FF5A00;">Mot de
                passe oublié ?</a>
            </div>
            <div class="form-group">
              <label for="#">Vous n'avez pas un compte ? <a [routerLink]="['/inscription']"
                  style="font-size: 13px; color: #FF5A00;">Inscrivez-vous</a></label>
            </div>
            <button type="submit" [disabled]="signInForm.invalid" *ngIf="!isLoading"
              class="btn btn-submit">Valider</button>
            <p class="text-danger" style="padding-top: 15px; margin-left: 15px;" *ngIf="isLoading">Veuillez patienter...
            </p>

          </form>
        </div>
      </div>
    </div>
  </div>

</section>